import React, { useState, useEffect } from "react";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { Routes, Route } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from "./firebase";
import Navbar from "./components/Navbar";
import { lightTheme, darkTheme } from "./theme";
import RoleLayout from "./layouts/RoleLayout";
import Login from "./components/Login";

const App = ({ toggleDarkMode, darkMode }) => {
  const [userRole, setUserRole] = useState(null);
  const [userId, setUserId] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userDocRef = doc(db, 'users', user.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            const userData = userDoc.data();
            setUserRole(userData.role);
            setUserId(userData.userId);
            setIsAuthenticated(true);
            console.log('App: User authenticated:', { userId: userData.userId, role: userData.role });
          } else {
            console.error('App: User data not found in Firestore');
            setIsAuthenticated(false);
            setUserRole(null);
            setUserId(null);
          }
        } catch (error) {
          console.error('App: Error fetching user data:', error);
          setIsAuthenticated(false);
          setUserRole(null);
          setUserId(null);
        }
      } else {
        console.log('App: No authenticated user, defaulting to customer role');
        setIsAuthenticated(false);
        setUserRole(null);
        setUserId(null);
      }
    });

    return () => unsubscribe();
  }, [auth]);

  const handleLoginSuccess = (role, userId, { companyCode, companyName }) => {
    setUserRole(role);
    setUserId(userId);
    setIsAuthenticated(true);
    console.log('App: Login success:', { role, userId, companyCode, companyName });
  };

  const selectedTheme = darkMode ? darkTheme : lightTheme;

  return (
    <ThemeProvider theme={selectedTheme}>
      <CssBaseline />
      <Box bgcolor={"background.default"} color={"text.primary"} minHeight="100vh">
        <Routes>
          <Route 
            path="/employee-login" 
            element={<Login onLoginSuccess={handleLoginSuccess} toggleDarkMode={toggleDarkMode} darkMode={darkMode} />} 
          />
          <Route 
            path="/*" 
            element={
              isAuthenticated ? (
                <RoleLayout 
                  darkMode={darkMode} 
                  toggleDarkMode={toggleDarkMode} 
                  role={userRole || 'customer'} 
                  userId={userId}
                  onLoginSuccess={handleLoginSuccess} 
                />
              ) : (
                <RoleLayout 
                  darkMode={darkMode} 
                  toggleDarkMode={toggleDarkMode} 
                  role="customer" 
                />
              )
            } 
          />
        </Routes>
      </Box>
    </ThemeProvider>
  );
};

export default App;